import { render, staticRenderFns } from "./RdArrow.vue?vue&type=template&id=63ad28dd&scoped=true&"
import script from "./RdArrow.vue?vue&type=script&lang=ts&"
export * from "./RdArrow.vue?vue&type=script&lang=ts&"
import style0 from "./RdArrow.vue?vue&type=style&index=0&id=63ad28dd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ad28dd",
  null
  
)

export default component.exports